import {UserEntity} from "../../../proto/generated/api_entities_pb";
import {IRegistration} from "./registrationsReducerTypes";
import {roleFromBackendIdentifier} from "../../../utils/helpers/acl/mapRoleAndBackendIdentifier";
import {UserStatus} from "../../../utils/constans/statuses/userStatuses";
import {mapCompanyEntityToICompany} from "../companyReducer/companyMappers";
import {mapTariffEntityToITariff} from "../tariffReducer/tariffMappers";

export const mapUserEntityToIRegistration = (item: UserEntity): IRegistration => {
  const company = item.getCompany();
  if (!company)
    throw new Error("Null CompanyEntity (company) in received UserEntity");

  const tariffEntity = item.getTariff();
  const tariff = tariffEntity ? mapTariffEntityToITariff(tariffEntity) : null;

  return {
    id: item.getUserid(),
    firstName: item.getFirstname(),
    lastName: item.getLastname(),
    middleName: item.getMiddlename(),
    email: item.getEmail(),
    phone: item.getPhone() && item.getPhone() !== 0 ? item.getPhone() : undefined,
    companyRole: roleFromBackendIdentifier(item.getRole()),
    userStatus: item.getUserstatusid() as UserStatus,
    company: mapCompanyEntityToICompany(company, item), // Pass userEntity to map International Flights documents
    tariff: tariff,
  }
}